import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
  name: 'appDateTimeUntil'
})
export class DateTimeUntilPipe implements PipeTransform {
  transform(date: Date | string) {
    if (!date) return '';
    return formatDate(date, 'yyyy-MM-dd', 'en-US', 'UTC');
  }
}
